module.exports = __webpack_public_path__ + "img/img-3.b41cb105.webp";